import { ErrorLogComponent } from '@cian/error-log-component';
import { uaToDeviceType, UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IReduxStore } from '../../store';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils/applicationContext';
import { PageContainer } from '../PageContainer';

export interface IApplicationProps {
  reduxStore: IReduxStore;
  context: IApplicationContext;
}

export const Application: React.FC<IApplicationProps> = props => {
  const { context, reduxStore } = props;

  return (
    <Provider store={reduxStore}>
      <ApplicationContext.Provider value={context}>
        <ErrorLogComponent logger={context.logger}>
          <UiKitRoot deviceType={uaToDeviceType(context.custom.userAgent)}>
            <PageContainer />
          </UiKitRoot>
        </ErrorLogComponent>
      </ApplicationContext.Provider>
    </Provider>
  );
};
